import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/home/HomeView.vue'
import CsaApartments from "@/views/booking/CsaApartments.vue";
import ApartmentDetails from "@/views/booking/ApartmentDetails.vue";
import BookingStep from "@/views/booking/BookingStep.vue";
import AboutView from "@/views/about/AboutView.vue";
import CsaHobies from "@/views/event-activities/CsaHobies.vue";
import CsaRestaurant from "@/views/restaurant/CsaRestaurant.vue";
import CsaGallery from "@/views/gallery/CsaGallery.vue";
import CsaContact from "@/views/about/CsaContact.vue";
import EventActivies from "@/views/event-activities/EventActivies.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/apartments',
    name: 'apartments',
    component: CsaApartments
  },
  {
    path: '/apartment/:id/details',
    name: 'apartment-details',
    component: ApartmentDetails
  },
  {
    path: '/book/apartment/:id',
    name: 'book-apartment',
    component: BookingStep
  },
  {
    path: '/about',
    name: 'about',
    component:AboutView
  },
  {
    path: '/hobbies',
    name: 'csa-hobbies',
    component:CsaHobies
  },
  {
    path: '/restaurant',
    name: 'csa-restaurant',
    component:CsaRestaurant
  },
  {
    path: '/gallery',
    name: 'gallery',
    component:CsaGallery
  },
  {
    path: '/contact/us',
    name: 'cas-contact',
    component:CsaContact
  },
  {
    path: '/events',
    name: 'cas-events',
    component:EventActivies
  },
  {
    path: "/:pathMatch(.*)",
    component: HomeView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
